module.exports = __webpack_public_path__ + "static/presidents-message-index-thumbnails-1920x1080-6f5d7810512261bb82aec4aeea1e47a7.jpg";